export const stripUnit = (value) => {
  return Number((value || "").toString().replace(/[^\d\.-]/gi, "")) || null;
};
